import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Subscribable } from './subscribable.mjs';
import { isServer } from './utils.mjs';
var FocusManager = /*#__PURE__*/function (_Subscribable) {
  _inherits(FocusManager, _Subscribable);
  var _super = _createSuper(FocusManager);
  function FocusManager() {
    var _this;
    _classCallCheck(this, FocusManager);
    _this = _super.call(this);
    _this.setup = function (onFocus) {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!isServer && window.addEventListener) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus

        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
      return;
    };
    return _this;
  }
  _createClass(FocusManager, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      if (!this.cleanup) {
        this.setEventListener(this.setup);
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.hasListeners()) {
        var _this$cleanup;
        (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
        this.cleanup = undefined;
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener(setup) {
      var _this2 = this;
      var _this$cleanup2;
      this.setup = setup;
      (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
      this.cleanup = setup(function (focused) {
        if (typeof focused === 'boolean') {
          _this2.setFocused(focused);
        } else {
          _this2.onFocus();
        }
      });
    }
  }, {
    key: "setFocused",
    value: function setFocused(focused) {
      var changed = this.focused !== focused;
      if (changed) {
        this.focused = focused;
        this.onFocus();
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.listeners.forEach(function (_ref) {
        var listener = _ref.listener;
        listener();
      });
    }
  }, {
    key: "isFocused",
    value: function isFocused() {
      if (typeof this.focused === 'boolean') {
        return this.focused;
      } // document global can be unavailable in react native

      if (typeof document === 'undefined') {
        return true;
      }
      return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
    }
  }]);
  return FocusManager;
}(Subscribable);
var focusManager = new FocusManager();
export { FocusManager, focusManager };